module.exports = __webpack_public_path__ + "static/media/5_r_Layer5_72.66_36.94.cc9f985e.png";